import React,{Component} from 'react';
import {resettingPassword,login} from '../../actions/authActions';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isValidPassword} from '../../utils/Validators';
import IndicatorButton from '../../components/IndicatorButton';
import Auth from '../../api/auth';
import {showError,showMessage} from '../../actions/uiActions';
import { withRouter } from '../../utils/withRouter';
class PasswordResetFormComponent extends Component
{
    state=
    {
        validating:false,
        id:0,
        token:'',
        error:false,
        success:false,
        password:'',
        confirm_password:'',
        valid_password:true,
        valid_password_confirmation:true,
        submitting:false
    }
    componentWillMount()
    {
        this.setState({id:this.props.match.params.id,token:this.props.match.params.token});
        this.props.resettingPassword();
    }
    handleOnChange=(e)=>
    {
        this.setState({[e.target.name]:e.target
        .value,valid_password:true,valid_password_confirmation:true});
        
    }
    handleOnSubmit=(e)=>
    {
        if(e)
            e.preventDefault();
        const passwordIsValid=isValidPassword(this.state.password);
        this.setState({valid_password:passwordIsValid,valid_password_confirmation:this.state.password===this.state.confirm_password});
        if(passwordIsValid&&this.state.password===this.state.confirm_password)
        {
            this.setState({submitting:true});
            Auth.resetPassword(this.state.id,this.state.password,this.state.token)
                .then(success=>this.setState({
                    submitting: false,
                    success: true,
                    error: false
                }))
                .catch(error=>{
                    this.props.showError();
                    this.setState({
                        submitting: false,
                        error: error.response.data.message,
                        success: false
                    });
                });
        }
    }
    render()
    {
        return <div className={this.state.validating?'container login loading animated flash infinite slower':'container login'}>
        <div className="row">
        <div className="col-xl-4 offset-xl-4 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-12">
        <div className="mat-card animated fadeIn">
        {!this.state.validating&&!this.state.success&&!this.state.error&&<div>
            <h1 style={{color: "black", fontWeight: '600', textAlign: "center"}}>Create a new Account Password</h1>
            <p style={{color: "black",  textAlign: "center"}}>Fill the form below to create a new account password.</p>
        <form onSubmit={this.handleOnSubmit}>
            <div className="form-group dark">
            <input disabled={this.state.submitting} type="password" autoComplete="new-password" name="password" value={this.state.password} onChange={this.handleOnChange} className="form-control branded-dark-input" placeholder="New Account Password" />
            {!this.state.valid_password&&<div className="input-error animated zoomIn" style={{color: "black",  textAlign: "center"}}>Password must have at least 12 characters, an uppercase letter, a lower case letter, a number and a special character.</div>}
            </div>
            <div className="form-group dark">
            <input disabled={this.state.submitting} type="password" autoComplete="new-password" name="confirm_password" value={this.state.confirm_password} onChange={this.handleOnChange} className="form-control branded-dark-input" placeholder="Confirm New Account Password" />
            {!this.state.valid_password_confirmation&&<div className="input-error animated zoomIn" style={{color: "black", textAlign: "center"}}>Passwords do not match</div>}
            </div>
        </form>
        <div className="row"><div className="col-12 text-center"><IndicatorButton className="btn-primary" disabled={this.state.submitting} onClick={this.handleOnSubmit}>Submit</IndicatorButton></div></div></div>}
        {this.state.success&&<div><h1>New Password Created</h1><p className="info">Your new account password has been saved. You may now proceed to log in using your new password.</p></div>}
        {this.state.error&&<div><h1>Error</h1><p className="info">
            {this.state.error || <span>There has been an error processing your request, this may be because the link you used either is not valid or has expired. You may refresh the page and try again, or you can request another link to reset your account password.</span>}
        </p></div>}
        
        {!this.state.validating&&(this.state.error||this.state.success)&&<div className="row"><div className="col-12 text-center"><Link to="/login"><button className="btn btn-primary">Go to login</button></Link></div></div>}
        </div>
        </div>
        </div>
        </div>
    }
}
const mapStateToProps= state =>{
    return {
        resettingPassword:state.auth.resetting_password
    }};
PasswordResetFormComponent.propTypes=
{
    resettingPassword: PropTypes.func.isRequired,
    login:PropTypes.func.isRequired
};
export default withRouter(connect(mapStateToProps,{resettingPassword,login,showError,showMessage})(PasswordResetFormComponent));